// extracted by mini-css-extract-plugin
module.exports = {"row":"stats_row__vukW3","group":"stats_group__h4RF2","total":"stats_total__jIAlu","overrides":"stats_overrides___ly1j"};